import React from 'react';
import useChart from '../../hooks/useChart'
import { LineChart, Line, YAxis, XAxis, CartesianGrid, Tooltip } from 'recharts';


const MyLineChart = () => {
    const [data, setData] = useChart()
    return (

        <div className="w-50 mt-3">
            <LineChart width={500} height={400} data={data}>
                <Line type="monotone" dataKey={'sell'}></Line>
                <CartesianGrid stroke="#ccc" />
                <YAxis></YAxis>
                <XAxis dataKey={'month'}></XAxis>
                <Tooltip />
            </LineChart>
            <h5 className='text-center'>sell</h5>
        </div>





    );
};

export default MyLineChart;